
import { Selector } from '@ngxs/store';
import { UserState, UserStateModel } from './UserState';
import { User } from '../models/user.model';
//import { TodoState, TodoStateModel, UserStateModel } from './todo-state';
export class UserSelectors {
  @Selector([UserState])
  static getUser(state: UserStateModel): User {
    return state.user;
  }
}
